module.exports = __webpack_public_path__ + "static/fonts/lato-v23-latin-ext_latin-regular.8f2ea05.eot";